// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"e74aea4d","256":"6bb230f1","871":"449d9f44"}[chunkId] + ".chunk.js";
};